const populateMetadata = media => {
    return {
        contentType: media.type,
        customMetadata: {
            name: media.name,
        },
    };
};

export { populateMetadata };
